import { usePollAISuggestionRequest } from 'hooks/queries/aiSuggestionRequests/usePollAISuggestionRequest'

export const useMaybeAISuggestionRequest = ({ requestId }: { requestId: number | undefined }) => {
  return usePollAISuggestionRequest(
    { id: requestId || -1 },
    {
      enabled: requestId !== undefined,
    },
  )
}
